import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEvaluationLegend1 = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "59px",
	height: "59px",
	viewBox: "0 0 59 59",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("rect", {
			stroke: "#50E3C2",
			strokeWidth: 2,
			x: 1,
			y: 1,
			width: 57,
			height: 57,
			rx: 13
		}), /* @__PURE__ */ _jsx("text", {
			fontFamily: "Raleway",
			fontSize: 16,
			fontWeight: 500,
			fill: "#50E3C2",
			children: /* @__PURE__ */ _jsx("tspan", {
				x: 38,
				y: 20,
				children: "KI"
			})
		})]
	})]
});
const ForwardRef = forwardRef(SvgEvaluationLegend1);
export { ForwardRef as ReactComponent };
